<template>
  <div class="contaniner">
    <i
      v-show="hasTabs"
      name="tabs"
      class="tabbar-action tabbar-action--left el-icon-d-arrow-left"
      title="向左滚动"
      @click="leftmove"
    ></i>
    <div ref="toolbar" class="toolbar">
      <!-- //左箭头 -->
      <el-tag
        class="toolItem"
        type="info"
        :disable-transitions="false"
        :closable="item.id != 0"
        effect="plain"
        v-for="(item, index) in getToolData"
        :key="index"
        :class="{ active: $route.path == item.detail }"
        @click="redirect(item)"
        @close="closeToolItem(item, index)"
      >
        <span class="dot" v-if="$route.path == item.detail"></span>
        <span class="toolItem__label ellipsis" :title="item.name">{{ item.name }}</span>
      </el-tag>
    </div>
    <i
      v-show="hasTabs"
      class="tabbar-action tabbar-action--close el-icon-circle-close"
      title="关闭全部标签"
      @click="closeAll"
    ></i>
    <i
      v-show="hasTabs"
      name="tabs"
      class="tabbar-action tabbar-action--right el-icon-d-arrow-right"
      title="向右滚动"
      @click="rightmove"
    ></i>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "tabar",
  data() {
    return {
      isLogistics: JSON.parse(sessionStorage.getItem("limit")).menuTreeList[0]
        .name,
    };
  },
  computed: {
    ...mapGetters(["getToolData", "getCacheView"]),
    hasTabs() {
      return this.getToolData.length > 0;
    },
  },
  watch: {
    "$route.path"() {
      this.scheduleActiveTabVisibility();
    },
    getToolData() {
      this.scheduleActiveTabVisibility();
    },
  },
  mounted() {
    this.scheduleActiveTabVisibility();
    if (window.ResizeObserver && this.$refs.toolbar) {
      this.toolbarResizeObserver = new window.ResizeObserver(
        this.scheduleActiveTabVisibility
      );
      this.toolbarResizeObserver.observe(this.$refs.toolbar);
    } else {
      window.addEventListener("resize", this.scheduleActiveTabVisibility);
    }
  },
  beforeDestroy() {
    if (this.toolbarResizeObserver) {
      this.toolbarResizeObserver.disconnect();
    }
    window.removeEventListener("resize", this.scheduleActiveTabVisibility);
    clearTimeout(this.activeTabVisibilityTimer);
  },
  updated() {
    if (!this.getToolData.length && this.isLogistics == "首页") {
      this.$router.push({ path: "/home/welcome" });
    } else if (!this.getToolData.length && this.isLogistics == "物流首页") {
      this.$router.push({ path: "/logisticsIndex" });
    }else if(!this.getToolData.length && this.isLogistics =="会员首页"){
       this.$router.push({ path: "/dashboard" });
    }
  },
  methods: {
    leftmove() {
      this.scrollToolbar(-1);
    },
    rightmove() {
      this.scrollToolbar(1);
    },
    scrollToolbar(direction) {
      const toolbar = this.$refs.toolbar;
      if (!toolbar) return;
      const distance = Math.max(Math.round(toolbar.clientWidth * 0.6), 120);
      if (toolbar.scrollBy) {
        toolbar.scrollBy({ left: direction * distance, behavior: "smooth" });
      } else {
        toolbar.scrollLeft += direction * distance;
      }
    },
    scheduleActiveTabVisibility() {
      clearTimeout(this.activeTabVisibilityTimer);
      this.$nextTick(() => {
        if (this._isBeingDestroyed || this._isDestroyed) return;
        clearTimeout(this.activeTabVisibilityTimer);
        this.activeTabVisibilityTimer = setTimeout(
          this.ensureActiveTabVisible,
          60
        );
      });
    },
    ensureActiveTabVisible() {
      const toolbar = this.$refs.toolbar;
      const activeTab = toolbar && toolbar.querySelector(".toolItem.active");
      if (!activeTab) return;
      const toolbarRect = toolbar.getBoundingClientRect();
      const activeRect = activeTab.getBoundingClientRect();
      if (activeRect.left < toolbarRect.left) {
        toolbar.scrollLeft -= Math.ceil(toolbarRect.left - activeRect.left);
      } else if (activeRect.right > toolbarRect.right) {
        toolbar.scrollLeft += Math.ceil(activeRect.right - toolbarRect.right);
      }
    },
    closeToolItem(item, index) {
      let tempIndex = this.getToolData.findIndex((v) => {
        if (this.$route.fullPath.indexOf("?") != -1) {
          return this.$route.fullPath.split("?")[0] == v.detail;
        } else {
          return this.$route.fullPath == v.detail;
        }
      });
      this.$store.dispatch("clearToolBar", item);
      this.$store.dispatch("clearCache", item.componentName);
      if (
        this.getToolData.length >= 1 &&
        this.getToolData.length === tempIndex &&
        tempIndex < index
      ) {
        this.$router.push({
          path: this.getToolData[index - 1].detail,
        });
      } else {
        if (
          this.getToolData.length &&
          !(this.getToolData.length >= tempIndex)
        ) {
          this.$router.push({
            path: this.getToolData[this.getToolData.length - 1].detail,
          });
        }
      }
      if (tempIndex == index && this.getToolData.length >= 1) {
        this.$router.push({
          path: this.getToolData[this.getToolData.length - 1].detail,
        });
      }
    },
    redirect(item) {
      if (item.componentName === "addStorage") {
        this.$store.commit("updateTabStorage", true);
      }

      this.$router.push({ path: item.detail });
    },
    closeAll() {
      this.$store.commit("closeTar");
    },
  },
};
</script>

<style scoped lang="scss">
.contaniner {
  position: relative;
  height: 32px;
  margin-left: 42px;
  overflow: hidden;
}

.toolbar {
  position: absolute;
  top: 0;
  right: 56px;
  left: 45px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 8px;
  box-sizing: border-box;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.toolbar::-webkit-scrollbar {
  display: none;
}
/deep/.dot {
  background: #409eff;
  width: 6px;
  display: inline-block;
  height: 6px;
  border-radius: 50%;
  margin-right: 3px;
  border: 1px solid transparent;
  flex: 0 0 auto;
}

.toolItem {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  max-width: 240px;
  height: 26px;
  line-height: 24px;
  padding: 0 10px;
  border-radius: 4px;
  box-sizing: border-box;
}

.toolItem__label {
  min-width: 0;
}

/deep/.el-tag .el-icon-close {
  flex: 0 0 auto;
  margin-left: 6px;
  color: #909399;
}
/deep/.el-tag--plain.el-tag--info {
  background-color: #fff;
  border: 1px solid #dcdfe6;
  text-align: center;
  color: #606266;
}
.active {
  background-color: #ecf5ff !important;
  border-color: #409eff !important;
  color: #409eff !important;
  font-weight: 500;
}
/deep/.el-tag--plain.el-tag--info:hover {
  cursor: pointer;
  border-color: #a0cfff;
  color: #409eff;
}

.tabbar-action {
  position: absolute;
  top: 0;
  z-index: 100;
  width: 28px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: #fff;
  color: #909399;
  cursor: pointer;
  transition: color 0.2s ease;
}

.tabbar-action:hover {
  color: #409eff;
}

.tabbar-action--left {
  left: 0;
}

.tabbar-action--close {
  right: 28px;
}

.tabbar-action--right {
  right: 0;
}
</style>
